const Breakpoint = {
  phone: '(min-width:568px)',
  tablet: '(min-width:1025px)',
  computer: '(min-width:1280px)',
};

export default Breakpoint;
